<script>
import includes from 'lodash/includes'
import map from 'lodash/map'
import find from 'lodash/find'
import get from 'lodash/get'
import Field from './../components/Field.vue'

import EventBus from './../eventBus.js'

import CampaignBlock from './../components/CampaignBlock.vue'

export default {
  name: 'campaign-fund-raising',
  components: {
      CampaignBlock,
  },
  props: {
      donateUrl: {
          type: String,
          required: false,
          default: '',
      }
  },
  data() {
      return {
          selectedCampaign: null,
          filterHover: false,
          filterData: {
              hasFilter: false,
              filteredCause: null,
          },
      }
  },
  mounted() {

  },
  computed: {

  },
  methods: {
      selectCampaign(selectedCampaign) {
          this.selectedCampaign = selectedCampaign;
      },

      filterCampaign(option) {
          if (option !== 'all') {
              this.filterData.hasFilter = true;
              this.filterData.filteredCause = option;
          } else {
              this.filterData.hasFilter = false;
              this.filterData.filteredCause = null;
          }

          this.filterHover = false;
      },
  },
  watch: {

  }
}
</script>
